export interface CoachSessionFilterItem {
  label: string;
  value: SessionFilters;
}

export enum SessionFilters {
  Attended = 'attendances.attended',
  NoShow = 'attendances.noShow',
  Excused = 'attendances.excused',
  NotRecorded = 'attendances.notRecorded',
  Coaching = 'sessionTypes.coaching',
  PersonalTraining = 'sessionTypes.personalTraining',
  Nutrition = 'sessionTypes.nutrition',
  Virtual = 'coachSessionStyle.virtual',
  InPerson = 'coachSessionStyle.inPerson',
}

export const sessionAttendanceFilters: CoachSessionFilterItem[] = [
  {
    value: SessionFilters.Attended,
    label: 'Attended',
  },
  {
    value: SessionFilters.NoShow,
    label: 'No show',
  },
  {
    value: SessionFilters.Excused,
    label: 'Excused absence',
  },
  {
    value: SessionFilters.NotRecorded,
    label: 'Not recorded',
  },
];

export const sessionTypeFilters = [
  {
    value: SessionFilters.Coaching,
    label: 'Coaching',
  },
  {
    value: SessionFilters.PersonalTraining,
    label: 'Personal training',
  },
  {
    value: SessionFilters.Nutrition,
    label: 'Nutrition',
  },
];

export const sessionStyleFilters = [
  {
    value: SessionFilters.Virtual,
    label: 'Virtual',
  },
  {
    value: SessionFilters.InPerson,
    label: 'In-person',
  },
];

export const allSessionFilters = [
  ...sessionAttendanceFilters,
  ...sessionTypeFilters,
  ...sessionStyleFilters,
];
